export default __webpack_public_path__ + "static/media/product-3-min.c4eb341f.jpg";